
      <div class="row">

        <div class=" col-md-7  padding-left-0px padding-right-0px">
         
            <div class="card position-fixed3">
              <div class="row">

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header wh-header border-bottom ">
                      <div class="row">
                        <!--<div class="col-md-1">
                          <a (click)="BackToServices()"><i class="fas fa-angle-double-left"></i></a>
                        </div>-->
                        <div class="col-md-9">
                         
                          <label class="label-size-2">{{ServiceName}}</label>
                        </div>
                        </div>
                      <div class="row" *ngIf="SelectedService">
                        <div class="col-md-3">
                          <label class="label-size-2 font-size-1rem">{{SelectedService.CategoryName}}</label>
                        </div>
                      </div>
                       
                      
                  
                    </div>
                    <div class="card-body padding-top-15px height-500px" *ngIf="SelectedService">
                      <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">

                        <div class="row">
                          <div class="card margin-left-auto margin-right-auto width-802px">
                            <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px">
                              <div class="row">
                                <div class="col-md-4">
                                  <label>Service Details</label>


                                </div>
                                <!--<div class="col-md-8 float-right text-align-end">

              <a (click)="Editgeneral()" class="nav-link-hand education-navlink">
                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
              </a>
            </div>-->

                              </div>
                            </div>
                            <div class="card-body ">
                              <div class="row">
                                <div class="col-md-6 border-right">
                                  <div class="row">


                                    <div class="col-md-6  text-align-right">
                                      <label for="firstName" class="font-size-14px">Code </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">


                                      <label class="font-size-14px">{{SelectedService.ServiceCode}}</label>
                                    </div>




                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Name </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.Name}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Tax(%) </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.Tax}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Service Type </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.ServiceType}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">UOM</label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.UOM}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Note</label>
                                    </div>
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.Note}}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="row">
                                    <div class="col-md-6  text-align-right">
                                      <label for="firstName" class="font-size-14px">Service Category </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">


                                      <label class="font-size-14px">{{SelectedService.ServiceCategory}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Revenue Category </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.RevenueCategory}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Default Commission </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.DefaultCommission}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Minimum Commission </label>
                                    </div>
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.MinimumCommission}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Maximum Commission </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.MaximumCommission}}</label>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 text-align-right">
                                      <label for="firstName" class="font-size-14px">Max Discount Allowed </label>
                                    </div>:
                                    <div class="col-md-5 text-align-left">
                                      <label class="font-size-14px">{{SelectedService.MaxDiscountAllowed}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="card margin-left-auto margin-right-auto width-802px  margin-top-12px">
                            <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px ">
                              <div class="row">
                                <div class="col-md-6 padding-right-0px">
                                  <label>Branch Map</label>
                                </div>
                                <!--<div class="col-md-6 float-right text-align-end">

              <a (click)="Editbranch()" class="nav-link-hand education-navlink">
                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
              </a>
            </div>-->
                              </div>
                            </div>
                            <div class="card-body padding-top-0px">
                              <div class="table-component overflow-x">
                                <div class="table-responsive overflow-x">


                                  <table class="table table-striped margin-left-zero">

                                    <thead class="">
                                      <tr>


                                        <th class="td-width-403px">Name</th>

                                        <th class="padding-left-0px">Cost</th>
                                        <th></th>

                                      </tr>
                                    </thead>
                                    <tbody class="table-body">
                                      <tr *ngFor="let l of BranchMapData">


                                        <td class="td-padding ">
                                          {{l.BranchName}}
                                        </td>

                                        <td class="td-padding ">
                                          <!--<input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                      readonly
                      min="1" max="10" />-->
                                          <label *ngIf="l.IsFacilityMapped == 'Mapped'"> {{l.BranchBasePrice}}</label>
                                          <label *ngIf="l.IsFacilityMapped != 'Mapped'"> Not Set</label>
                                        </td>
                                        <td></td>

                                        <!--<td><a *ngIf="l.IsFacilityMapped =='Mapped'" (click)="del_(l.ActorDocPageCode)"><i class="far fa-trash-alt"></i></a></td>-->



                                      </tr>

                                    </tbody>

                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="card margin-left-auto margin-right-auto width-802px  margin-top-12px">
                            <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px ">
                              <div class="row">
                                <div class="col-md-4">
                                  <label>Consultant Map</label>
                                </div>
                                <div class="col-md-8 float-right text-align-end">
                                  <!--<button type="button" (click)="Addconsultant()" class="btn btn-primary btn-sm nav-link-hand"><i class="fas fa-plus"></i></button>-->
                                  <a (click)="Editconsultant()" class="nav-link-hand education-navlink">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="card-body padding-top-0 padding-left-0px">

                              <div class="card alerts-note-form ">
                                <div class="card-body padding-top padding-left-8 padding-right-9 " *ngIf="ShowList">


                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped margin-left-zero"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>

                                            <th class="">Branch</th>

                                            <th class="">Consultant</th>

                                            <th class="">C Factor</th>

                                            <th class="text-align-right">C %</th>
                                            <th class="">Provider Cost</th>
                                            <th class="text-align-right">Commission</th>


                                            <!--<th class=""></th>-->




                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of ConsultantMapData">


                                            <td class=" td-padding "> {{l.BranchShortName}}</td>
                                            <td class=" td-padding text-align-left"> {{l.DisplayName}}</td>

                                            <td class=" td-padding text-align-center">{{l.CommissionFactor}}</td>

                                            <td class=" td-padding text-align-right">{{l.CommissionPercentage}}</td>
                                            <td class=" td-padding text-align-center">{{l.ChargeAmount}}</td>

                                            <td class=" td-padding text-align-right">{{l.CommissionAmount}}</td>


                                            <!--<td class=" td-padding text-align-center">
                          <button type="button" (click)="edit_()"
                                  class="btn  actions-btn-prime2 benfits-button font-size margin-left-zero border-color " title="Edit">

                            <i class="fas fa-pencil-alt color-edit-icon"></i>
                          </button>
                        </td>-->




                                          </tr>

                                        </tbody>

                                      </table>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                </div>

              </div>


            </div>


         


        </div>

        <div class=" col-md-3 margin-left-51px padding-left-0px" *ngIf="SelectedService">
          <div class="card position-fixed-service2 affix">
            <label class="font-size-14 color5 margin-left-10px margin-top-10 margin-bottom-0px">{{ServiceName}}</label>
            <label class="font-size-13px margin-left-10px">{{SelectedService.CategoryName}}</label>
            <div class="row">
              <div class="col-md-12 padding-right-23px">
                <div class="badge badge-service-new margin-left-10px ">
                  <div class="row">
                    <label class="margin-bottom-0px margin-left-13px color-datacolor"> Base Price</label>
                  </div>
                  <div class="row">
                    <label class="margin-top-4px margin-left-auto margin-right-auto font-size-20px color5">{{SelectedService.BasePrice}}</label>
                  </div>

                </div>
              </div>
            </div>
          

          </div>

        </div>

        </div>
     

    
  


